import { render, staticRenderFns } from "./OrderSearchFiltersHeader.vue?vue&type=template&id=47a52b0e&scoped=true&"
import script from "./OrderSearchFiltersHeader.vue?vue&type=script&lang=js&"
export * from "./OrderSearchFiltersHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderSearchFiltersHeader.vue?vue&type=style&index=0&id=47a52b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a52b0e",
  null
  
)

export default component.exports